import { Icon, Text } from '@msc-b2c/shared-components';
import styles from './overview.module.scss';
import {
  checkAndSetDifficulty,
  managePlurals,
  replacePlaceholders,
  RootState,
} from '@msc-b2c/shared-utils';
import { useSelector } from 'react-redux';
import { getLanguageLabelFromCode } from '../../../utils/myAreaUtils';
import { OverviewProps } from '@msc-b2c/interfaces/interfaces';

function Overview({ excursion }: Readonly<OverviewProps>) {
  const drawerAEMConfig = useSelector((state: RootState) => state.myAreaCommonConfig.drawerProps);
  const drawerExcursionAEMConfig = useSelector(
    (state: RootState) => state.myAreaCommonConfig.drawerExcursionProps?.drawerExcursionType
  );
  const cardAEMConfig = useSelector(
    (state: RootState) => state.myAreaCommonConfig.prePaidCardProps
  );

  const activityDetails = excursion?.activityDetails;

  const isMultilingual =
    activityDetails?.guideLanguageCodes && activityDetails.guideLanguageCodes.length > 1;

  const difficultyLevel = activityDetails?.difficultyLevel
    ? checkAndSetDifficulty(activityDetails?.difficultyLevel)
    : '';

  const activityDetailsCollection = drawerExcursionAEMConfig?.activityDetailCollection ?? [];

  // find difficultyLevel in the activityDetailsCollection and return the correspondent label
  const difficultyLevelLabel = activityDetailsCollection.find(
    (item) => item.activityType === difficultyLevel
  )?.activityLabel;

  const overviewCharacteristics = {
    [drawerAEMConfig.difficultyLevelLabel]:
      difficultyLevelLabel ?? activityDetails?.difficultyLevel ?? '',
    ...((excursion?.duration ?? 0) > 0 && {
      [cardAEMConfig.durationLabel]: `${excursion?.duration} ${managePlurals(
        excursion?.duration ?? 0,
        drawerExcursionAEMConfig?.hoursLabel
      )}`,
    }),
    [drawerAEMConfig.tourLanguageLabel]: isMultilingual
      ? drawerExcursionAEMConfig?.multilingualLabel
      : replacePlaceholders(drawerExcursionAEMConfig?.singleLanguageLabel ?? '', {
          singleLanguage: getLanguageLabelFromCode(activityDetails?.guideLanguageCodes?.[0]) ?? '',
        }),
    [drawerAEMConfig.minimumParticipantsLabel]: activityDetails?.minimumPassengersRequired ?? '',
  };

  // loop into the drawerExcursionAEMConfig.activityDetailCollection and check for each type (activityType) the correspondent key in activityDetails
  // if in the activityDetails there is a key with the same name of the activityType and the boolean is true then add the key to the overviewCharacteristics
  activityDetailsCollection.forEach((overviewActivityObject) => {
    const activityDetailType = overviewActivityObject.activityType;
    const activityDetailValue = activityDetails?.[activityDetailType];
    if (activityDetailValue) {
      overviewCharacteristics[overviewActivityObject.activityTitle ?? drawerAEMConfig.otherLabel] =
        overviewActivityObject.activityLabel;
    }
  });

  return (
    <div className={styles['drawer-overview']}>
      <div className={styles['drawer-overview__title']}>
        {drawerExcursionAEMConfig?.overviewExcursionLabel}
      </div>
      <div
        className={styles['drawer-overview__description']}
        dangerouslySetInnerHTML={{
          __html: `${drawerExcursionAEMConfig?.overviewExcursionDescription ?? ''}`,
        }}
      ></div>
      <div className={styles['drawer-overview__elements--container']}>
        {Object.entries(overviewCharacteristics).map(
          ([key, value]) =>
            key &&
            value && (
              <div
                key={`overview-${key}`}
                className={styles['drawer-overview__elements--container__info']}
              >
                {drawerExcursionAEMConfig?.displayActivityIcons && <Icon icon="airplane" />}
                {/* HERE MODIFY THE ICON WHEN THE GENERIC LIST IS READY SO IT GOES WITH THE ASSOCIATED ICON - ACTIVITY DETAIL*/}
                <div className={styles.label}>
                  <Text text={key} />
                </div>
                <div className={styles.value}>
                  <Text text={value?.toString()} />
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
}

export default Overview;
